/**
 * Do not edit directly!
 * Changes will be overriden by Style Dictionary.
 */

module.exports = [
  'brand-primary',
  'brand-primary-tint-10',
  'brand-primary-tint-20',
  'brand-primary-tint-30',
  'brand-primary-tint-40',
  'brand-primary-tint-50',
  'brand-primary-tint-60',
  'brand-primary-tint-70',
  'brand-primary-tint-80',
  'brand-primary-tint-90',
  'brand-primary-tint-95',
  'brand-primary-shade-10',
  'brand-primary-shade-20',
  'brand-primary-shade-30',
  'brand-primary-shade-40',
  'brand-primary-shade-50',
  'brand-primary-shade-60',
  'brand-primary-shade-70',
  'brand-primary-shade-80',
  'brand-primary-shade-90',
  'brand-secondary',
  'brand-secondary-tint-10',
  'brand-secondary-tint-20',
  'brand-secondary-tint-30',
  'brand-secondary-tint-40',
  'brand-secondary-tint-50',
  'brand-secondary-tint-60',
  'brand-secondary-tint-70',
  'brand-secondary-tint-80',
  'brand-secondary-tint-90',
  'brand-secondary-tint-95',
  'brand-secondary-shade-10',
  'brand-secondary-shade-20',
  'brand-secondary-shade-30',
  'brand-secondary-shade-40',
  'brand-secondary-shade-50',
  'brand-secondary-shade-60',
  'brand-secondary-shade-70',
  'brand-secondary-shade-80',
  'brand-secondary-shade-90',
  'black',
  'white',
  'red',
  'red-tint-10',
  'red-tint-20',
  'red-tint-30',
  'red-tint-40',
  'red-tint-50',
  'red-tint-60',
  'red-tint-70',
  'red-tint-80',
  'red-tint-90',
  'red-tint-95',
  'red-shade-10',
  'red-shade-20',
  'red-shade-30',
  'red-shade-40',
  'red-shade-50',
  'red-shade-60',
  'red-shade-70',
  'red-shade-80',
  'red-shade-90',
  'yellow',
  'yellow-tint-10',
  'yellow-tint-20',
  'yellow-tint-30',
  'yellow-tint-40',
  'yellow-tint-50',
  'yellow-tint-60',
  'yellow-tint-70',
  'yellow-tint-80',
  'yellow-tint-90',
  'yellow-tint-95',
  'yellow-shade-10',
  'yellow-shade-20',
  'yellow-shade-30',
  'yellow-shade-40',
  'yellow-shade-50',
  'yellow-shade-60',
  'yellow-shade-70',
  'yellow-shade-80',
  'yellow-shade-90',
  'green',
  'green-tint-10',
  'green-tint-20',
  'green-tint-30',
  'green-tint-40',
  'green-tint-50',
  'green-tint-60',
  'green-tint-70',
  'green-tint-80',
  'green-tint-90',
  'green-tint-95',
  'green-shade-10',
  'green-shade-20',
  'green-shade-30',
  'green-shade-40',
  'green-shade-50',
  'green-shade-60',
  'green-shade-70',
  'green-shade-80',
  'green-shade-90',
  'blue',
  'blue-tint-10',
  'blue-tint-20',
  'blue-tint-30',
  'blue-tint-40',
  'blue-tint-50',
  'blue-tint-60',
  'blue-tint-70',
  'blue-tint-80',
  'blue-tint-90',
  'blue-tint-95',
  'blue-shade-10',
  'blue-shade-20',
  'blue-shade-30',
  'blue-shade-40',
  'blue-shade-50',
  'blue-shade-60',
  'blue-shade-70',
  'blue-shade-80',
  'blue-shade-90',
  'grey',
  'grey-tint-10',
  'grey-tint-20',
  'grey-tint-30',
  'grey-tint-40',
  'grey-tint-50',
  'grey-tint-60',
  'grey-tint-70',
  'grey-tint-80',
  'grey-tint-90',
  'grey-tint-95',
  'grey-shade-10',
  'grey-shade-20',
  'grey-shade-30',
  'grey-shade-40',
  'grey-shade-50',
  'grey-shade-60',
  'grey-shade-70',
  'grey-shade-80',
  'grey-shade-90',
  'danger',
  'attention',
  'success',
  'interaction',
  'neutral',
  'muted',
  'disabled',
  'inverted',
  'invertedMuted',
  'appBackground',
  'focused'
];